<h1>TABLA DE ERRORES</h1>
<div class="tabla">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->
      
        <!-- Position Column -->
        <ng-container matColumnDef="tipoError">
          <th mat-header-cell *matHeaderCellDef> Error de Tipo. </th>
          <td mat-cell *matCellDef="let element"> {{element.tipoError}} </td>
        </ng-container>
      
        <!-- Name Column -->
        <ng-container matColumnDef="Descripcion">
          <th mat-header-cell *matHeaderCellDef> Descripcion </th>
          <td mat-cell *matCellDef="let element"> {{element.desc}} </td>
        </ng-container>
      
        <!-- Weight Column -->
        <ng-container matColumnDef="Linea">
          <th mat-header-cell *matHeaderCellDef> Linea </th>
          <td mat-cell *matCellDef="let element"> {{element.fila}} </td>
        </ng-container>
      
        <!-- Symbol Column -->
        <ng-container matColumnDef="Columna">
          <th mat-header-cell *matHeaderCellDef> Columna </th>
          <td mat-cell *matCellDef="let element"> {{element.columna}} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
</div>